<app-sidebar></app-sidebar>

<section class="main-section">
  <app-header></app-header>

  <div class="home-body">
    <router-outlet></router-outlet>
  </div>
</section>

@if (showPublishedAgreement) {
  <app-published-agreement-modal
    [loading]="agreeingToPublishedAgreement"
    (agree)="onAgreePublishedAgreement()"
    (cancel)="onCancelPublishedAgreement()"
  ></app-published-agreement-modal>
}

@if (showAgreementSuccess) {
  <app-agreement-success-modal
    (goToHardware)="onGoToHardware()"
    (integrateLater)="onIntegrateLater()"
  ></app-agreement-success-modal>
}

@if (showChoosePos) {
  <app-choose-pos-modal
    [loading]="enablingFnf"
    [canConnectPos]="canConnectPos"
    (enableFnf)="onEnableFnfFromPrompt()"
    (connectPos)="onConnectPosFromPrompt()"
    (later)="onChoosePosLater()"
  ></app-choose-pos-modal>
}

@if (showWhatsNewSettings) {
  <app-whats-new-settings-modal
    (openSettings)="onWhatsNewOpenSettings()"
    (dismiss)="onWhatsNewSettingsDismiss()"
  ></app-whats-new-settings-modal>
}
